import type { PropsWithChildren, ReactElement } from "react";

import type { IPlainTooltipProps } from "@similarweb/ui-components";

import { TOOLTIP_WIDTH } from "./const";
import { StyledSignalsTooltip, StyledTooltipTrigger } from "./styles";

type Props = PropsWithChildren<
    IPlainTooltipProps & {
        content: ReactElement | string | number;
    }
>;

const SignalsTooltip = (props: Props) => {
    const { content, children, placement = "right", ...tooltipProps } = props;

    return (
        <StyledSignalsTooltip
            maxWidth={TOOLTIP_WIDTH}
            {...tooltipProps}
            variation="white"
            placement={placement}
            tooltipContent={content}
        >
            <StyledTooltipTrigger>{children}</StyledTooltipTrigger>
        </StyledSignalsTooltip>
    );
};

export default SignalsTooltip;
